import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, JobNote } from "@/types";

export function useDeleteJobNote() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({ jobNoteId }: { jobNoteId: number }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/job-notes/${jobNoteId.toString()}`;
      const res = await guacHttpClient.delete<JobNote, HttpResponse<JobNote>>(
        path,
      );

      return res.data;
    },
  });

  return mutation;
}
